<template>
  <div class="output-setting">
    <!-- Confirmation modal -->
    <b-modal
      id="removeOutput_ConfirmModal"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      :scrollable="true"
      size="md"
    >
      <VpConfirmModal modalId="removeOutput_ConfirmModal" :hasCloseIcon="true">
        <template v-slot:title>
          <span>{{ deselectOutput.label }}</span>
        </template>

        <template v-slot:text1>
          <span>
            Are you sure you want to <strong>“Apply”</strong> this action?
          </span>
        </template>

        <template v-slot:text2>
          <span>
            Unchecking the “Sign in”, “Sign out”, and “Check in” options will remove “{{ deselectOutput.label }}” from this flow.
          </span>
        </template>

        <template v-slot:buttons>
          <VpButton text="Apply" @click="onConfirmationModalSubmit" />
          <VpButton
            text="Cancel"
            :disabled="false"
            :isDanger="true"
            @click="onCancel"
          />
        </template>
      </VpConfirmModal>
    </b-modal>
    <!-- Confirmation modal -->

    <div class="header">
      <h5>{{ $t("journeyBuilder.outputSettings") }}</h5>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="vp-pos-absolute vp-right-32 vp-top-32"
        @click="onHideModal"
      >
        <path
          d="M11 0C4.91333 0 0 4.88342 0 10.933C0 16.9826 4.91333 21.8661 11 21.8661C17.0867 21.8661 22 16.9826 22 10.933C22 4.88342 17.0867 0 11 0ZM16.5978 14.626C17.1111 15.1362 17.1111 15.9622 16.5978 16.4724C16.3289 16.7397 16.0111 16.8612 15.6689 16.8612C15.3267 16.8612 14.9844 16.7397 14.74 16.4724L11.0733 12.8281L7.38222 16.4724C7.11333 16.7397 6.79556 16.8612 6.45333 16.8612C6.11111 16.8612 5.76889 16.7397 5.52444 16.4724C5.01111 15.9622 5.01111 15.1362 5.52444 14.626L9.21556 10.9573L5.52444 7.31298C5.01111 6.80277 5.01111 5.97672 5.52444 5.46651C6.03778 4.95631 6.86889 4.95631 7.38222 5.46651L11.0733 9.13515L14.7644 5.46651C15.2778 4.95631 16.1089 4.95631 16.6222 5.46651C17.1356 5.97672 17.1356 6.80277 16.6222 7.31298L12.9311 10.9816L16.5978 14.626Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <div v-for="(output, index) in applyOutputSettings" :key="output.name">
      <!-- start:: print bade -->
      <div v-if="output.name === 'print_badge'">
        <div class="subheader-container header-title">
          <h5 class="fw-700">{{ $t('journeyBuilder.flow.printBadge')}}</h5>
        </div>
        <div class="checkbox-container">
          <b-form-checkbox
            @change="onLoginModeChange(output, 'checkIn')"
            v-model="$v.applyOutputSettings.$each.$iter[index].checkIn.$model"
            >{{ $t("common.checkIn") }}</b-form-checkbox
          >
          <b-form-checkbox
            @change="onLoginModeChange(output, 'signIn')"
            v-model="$v.applyOutputSettings.$each.$iter[index].signIn.$model"
            >{{ $t("common.signIn") }}</b-form-checkbox
          >
          <b-form-checkbox
            @change="onLoginModeChange(output, 'signOut')"
            v-model="$v.applyOutputSettings.$each.$iter[index].signOut.$model"
            >{{ $t("common.signOut") }}</b-form-checkbox
          >
        </div>

        <div class="subheader-container">
          <h5>{{ $t("journeyBuilder.flow.showBadge") }}</h5>
        </div>
        <div
          v-for="setting in output.chlidren"
          :key="setting.id"
          class="setting-container"
          :class="{
            'display-setting': isDisplayed(setting, output),
            'display-none-animated': !isDisplayed(setting, output),
            'd-none': setting.id == '12' || setting.id == '13',
          }"
        >
          <!-- Exclude 'company name' (id = 12) & 'Date and time' (id = 13) settings  -->
          <span
            >{{ setting.label }}
            <svg
              v-if="setting.id == 113"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-inline-start: 8px"
              v-b-tooltip
              id="tooltip-svg"
            >
              <path
                d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                fill="#787878"
              />
            </svg>
            <b-tooltip
              placement="bottom"
              id="journey-logo-tooltip"
              target="tooltip-svg"
              triggers="click blur"
            >
              {{ $t("journeyBuilder.notes.logoPrint") }}
            </b-tooltip>
          </span>
          <b-form-checkbox
            class="switch-gray custom-switch-input"
            switch
            size="lg"
            v-model="
              $v.applyOutputSettings.$each.$iter[index].chlidren[setting.name]
                .value.$model
            "
          ></b-form-checkbox>
        </div>

        <div v-if="displayCustomFields(output)">
          <hr class="vp-mb-32" />
          <div v-for="(value, key) in printBadgeCustomFields" :key="key">
          
              <template v-if="key == 'checkInCustomFileds' && output.checkIn && (printBadgeCustomFields[key].userTypes.some(userType=> !!userType.sections.some(section => !!section.checkInCustomFields.length)) || printBadgeCustomFields[key].sections?.length)">
                <h3 class="vp-mb-16 print-badge-custom-field-header">Check In Badge Custom Fields:</h3>
                <ul class="print-badge-user-types-container">
                  <li
                     v-for="(userType, index) in (
                      printBadgeCustomFields[key].sections?.length
                        ? printBadgeCustomFields[key].userTypes
                        : printBadgeCustomFields[key].userTypes.filter(userType =>
                            userType.sections?.some(section => !!section.children?.length)
                          )
                    )"
                    :key="userType.id"
                    class="user-type-tag inactive-tag"
                    :class="{
                      'background-blue': index == checkInCurrentUserTypeIndex,
                    }"
                    @click="onUserTypeSelect(index, key, userType.id)"
                  >
                    {{ userType.name }}
                  </li>

                <div style="position: relative;">
                  <VpTreeselect
                    :disabled="!applyPrintBadgeCustomFields || !$v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                      checkInCurrentUserTypeIndex
                      ].$model.permitted"
                    :disableBranchNodes="true"
                    class="vp-mt-16"
                    :showPlaceholderIcon="true"
                    width="416"
                    valueFormat="object"
                    :showOptionsBorder="true"
                    label="Custom field (optional)"
                    v-model="
                      $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                        checkInUserTypeIndex
                      ].printBadgeCustomFields.$model
                    "
                    :options="checkInCustomFieldsOptions(checkInCurrentUserTypeIndex)"
                    :isMultiple="true"
                    :optionsKey="checkInOptionsKey"
                    @deselect="checkInDeselectHandler($event, checkInCurrentUserTypeIndex)"
                  />
                  <svg
                    v-show="!applyPrintBadgeCustomFields"
                    class="lock-icon"
                    :class="{'lock-icon-with-value': $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                      checkInCurrentUserTypeIndex
                      ].printBadgeCustomFields.$model && $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                      checkInCurrentUserTypeIndex
                      ].printBadgeCustomFields.$model.length}"
                    width="12"
                    height="16"
                    v-b-tooltip
                    id="check-in-lock-icon"
                    viewBox="0 0 17 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.2691 7.29675V5.68077C14.2363 4.16287 13.614 2.71827 12.5357 1.65644C11.4574 0.594606 10.0087 0 8.5 0C6.99132 0 5.54264 0.594606 4.46431 1.65644C3.38597 2.71827 2.76374 4.16287 2.73092 5.68077V7.29675C2.00664 7.29675 1.31202 7.5863 0.799869 8.1017C0.287721 8.6171 0 9.31614 0 10.045V19.2517C0 19.9806 0.287721 20.6796 0.799869 21.195C1.31202 21.7104 2.00664 22 2.73092 22H14.2691C14.9934 22 15.688 21.7104 16.2001 21.195C16.7123 20.6796 17 19.9806 17 19.2517V10.045C17 9.31614 16.7123 8.6171 16.2001 8.1017C15.688 7.5863 14.9934 7.29675 14.2691 7.29675ZM9.591 16.1929C9.591 16.4845 9.47591 16.7641 9.27106 16.9702C9.0662 17.1764 8.78835 17.2922 8.49863 17.2922C8.20892 17.2922 7.93107 17.1764 7.72621 16.9702C7.52135 16.7641 7.40626 16.4845 7.40626 16.1929V13.1011C7.40626 12.8095 7.52135 12.5299 7.72621 12.3238C7.93107 12.1176 8.20892 12.0018 8.49863 12.0018C8.78835 12.0018 9.0662 12.1176 9.27106 12.3238C9.47591 12.5299 9.591 12.8095 9.591 13.1011V16.1929ZM12.0843 7.29675H4.91566V5.68077C4.94143 4.74134 5.33037 3.8491 5.99975 3.1938C6.66914 2.53851 7.56615 2.17187 8.5 2.17187C9.43385 2.17187 10.3309 2.53851 11.0002 3.1938C11.6696 3.8491 12.0586 4.74134 12.0843 5.68077V7.29675Z"
                      fill="#103F5E"
                    />
                  </svg>
                  <b-tooltip
                  id="lock-icon-tooltip"
                  target="check-in-lock-icon"
                  triggers="click blur"
                  placement="topright"
                  >
                    <ul style="margin-bottom: 0px">
                      <li
                        class="feature-availability"
                        style="margin-bottom: 8px; text-align: start"
                      >
                        {{ $t("customFields.form.lockedFeature") }}
                      </li>

                      <li class="feature-upgrade" style="text-align: start">
                        {{ $t("customFields.form.lockedFeatureInfo") }}
                        <span
                          class="mail"
                          style="
                            color: #2680eb;
                            font-weight: 700;
                            text-decoration: underline;
                          "
                          >cs@lamasatech.com.</span
                        >
                      </li>
                    </ul>
                  </b-tooltip>

                  <template v-if="applyPrintBadgeCustomFields">
                      <p class="maximum-custom-field-note">
                        <template v-if="!$v.printBadgeMetadataTemp[key].userTypes.$each.$iter[checkInCurrentUserTypeIndex].$model.permitted">
                            <b>Note:</b> You cannot access the custom fields because you do not have permission to access this user type.
                        </template>
                        <template v-else>
                            <b>Note:</b> A maximum of 4 custom fields can be printed.
                        </template>
                      </p>
                  </template>
                  </div>
                </ul>
              <hr class="vp-mt-32 vp-mb-32" />
              </template>

              <template v-if="key == 'signInCustomFileds' && output.signIn  && (printBadgeCustomFields[key].userTypes.some(userType=> !!userType.sections.some(section => !!section.signInCustomFields.length)) || printBadgeCustomFields[key].sections?.length)">
                <h3 class="vp-mb-16 print-badge-custom-field-header">Sign In Badge Custom Fields:</h3>
                <ul class="print-badge-user-types-container">
                  <li
                      v-for="(userType, index) in (
                        printBadgeCustomFields[key].sections?.length
                          ? printBadgeCustomFields[key].userTypes
                          : printBadgeCustomFields[key].userTypes.filter(userType =>
                              userType.sections?.some(section => !!section.children?.length)
                            )
                      )"
                    :key="userType.id"
                    class="user-type-tag inactive-tag"
                    :class="{
                      'background-blue': index == signInCurrentUserTypeIndex,
                    }"
                    @click="onUserTypeSelect(index, key, userType.id)"
                  >
                    {{ userType.name }}
                  </li>
                  <div style="position: relative;">
                  <VpTreeselect
                    class="vp-mt-16"
                    :disabled="!applyPrintBadgeCustomFields || !$v.printBadgeMetadataTemp[key].userTypes.$each.$iter[signInCurrentUserTypeIndex].$model.permitted"
                    :showPlaceholderIcon="true"
                    label="Custom field (optional)"
                    width="416"
                    :showOptionsBorder="true"
                    valueFormat="object"
                    v-model="
                      $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                        signInUserTypeIndex
                      ].printBadgeCustomFields.$model
                    "
                    :options="signInCustomFieldsOption(signInCurrentUserTypeIndex)"
                    :optionsKey="signInOptionsKey"
                    :isMultiple="true"
                    :disableBranchNodes="true"
                    @deselect="signInDeselectHandler($event, signInCurrentUserTypeIndex)"
                  />
                  <svg
                    v-show="!applyPrintBadgeCustomFields"
                    class="lock-icon"
                    :class="{'lock-icon-with-value': $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                      signInCurrentUserTypeIndex
                      ].printBadgeCustomFields.$model && $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                      signInCurrentUserTypeIndex
                      ].printBadgeCustomFields.$model.length}"
                    width="12"
                    height="16"
                    v-b-tooltip
                    id="sign-in-lock-icon"
                    viewBox="0 0 17 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.2691 7.29675V5.68077C14.2363 4.16287 13.614 2.71827 12.5357 1.65644C11.4574 0.594606 10.0087 0 8.5 0C6.99132 0 5.54264 0.594606 4.46431 1.65644C3.38597 2.71827 2.76374 4.16287 2.73092 5.68077V7.29675C2.00664 7.29675 1.31202 7.5863 0.799869 8.1017C0.287721 8.6171 0 9.31614 0 10.045V19.2517C0 19.9806 0.287721 20.6796 0.799869 21.195C1.31202 21.7104 2.00664 22 2.73092 22H14.2691C14.9934 22 15.688 21.7104 16.2001 21.195C16.7123 20.6796 17 19.9806 17 19.2517V10.045C17 9.31614 16.7123 8.6171 16.2001 8.1017C15.688 7.5863 14.9934 7.29675 14.2691 7.29675ZM9.591 16.1929C9.591 16.4845 9.47591 16.7641 9.27106 16.9702C9.0662 17.1764 8.78835 17.2922 8.49863 17.2922C8.20892 17.2922 7.93107 17.1764 7.72621 16.9702C7.52135 16.7641 7.40626 16.4845 7.40626 16.1929V13.1011C7.40626 12.8095 7.52135 12.5299 7.72621 12.3238C7.93107 12.1176 8.20892 12.0018 8.49863 12.0018C8.78835 12.0018 9.0662 12.1176 9.27106 12.3238C9.47591 12.5299 9.591 12.8095 9.591 13.1011V16.1929ZM12.0843 7.29675H4.91566V5.68077C4.94143 4.74134 5.33037 3.8491 5.99975 3.1938C6.66914 2.53851 7.56615 2.17187 8.5 2.17187C9.43385 2.17187 10.3309 2.53851 11.0002 3.1938C11.6696 3.8491 12.0586 4.74134 12.0843 5.68077V7.29675Z"
                      fill="#103F5E"
                    />
                  </svg>
                  <b-tooltip
                  id="lock-icon-tooltip"
                  target="sign-in-lock-icon"
                  triggers="click blur"
                  placement="topright"
                  >
                    <ul style="margin-bottom: 0px">
                      <li
                        class="feature-availability"
                        style="margin-bottom: 8px; text-align: start"
                      >
                        {{ $t("customFields.form.lockedFeature") }}
                      </li>

                      <li class="feature-upgrade" style="text-align: start">
                        {{ $t("customFields.form.lockedFeatureInfo") }}
                        <span
                          class="mail"
                          style="
                            color: #2680eb;
                            font-weight: 700;
                            text-decoration: underline;
                          "
                          >cs@lamasatech.com.</span
                        >
                      </li>
                    </ul>
                  </b-tooltip>
                  <template v-if="applyPrintBadgeCustomFields">
                    <p class="maximum-custom-field-note">
                      <template v-if="!$v.printBadgeMetadataTemp[key].userTypes.$each.$iter[signInCurrentUserTypeIndex].$model.permitted">
                          <b>Note:</b> You cannot access the custom fields because you do not have permission to access this user type.
                      </template>
                      <template v-else>
                          <b>Note:</b> A maximum of 4 custom fields can be printed.
                      </template>
                    </p>
                  </template>
                  </div>
                </ul>
              <hr class="vp-mt-32 vp-mb-32" />
              </template>

              <template v-if="key == 'signOutCustomFileds' && output.signOut  && (printBadgeCustomFields[key].userTypes.some(userType=> !!userType.sections.some(section => !!section.signOutCustomFields.length)) || printBadgeCustomFields[key].sections?.length)">
                <h3 class="vp-mb-16 print-badge-custom-field-header">Sign Out Badge Custom Fields:</h3>
                <ul class="print-badge-user-types-container">
                  <li
                     v-for="(userType, index) in (
                      printBadgeCustomFields[key].sections?.length
                        ? printBadgeCustomFields[key].userTypes
                        : printBadgeCustomFields[key].userTypes.filter(userType =>
                            userType.sections?.some(section => !!section.children?.length)
                          )
                    )"
                    :key="userType.id"
                    class="user-type-tag inactive-tag"
                    :class="{
                      'background-blue': index == signOutCurrentUserTypeIndex,
                    }"
                    @click="onUserTypeSelect(index, key, userType.id)"
                  >
                    <span>{{ userType.name }}</span>
                  </li>
                  <div style="position: relative;">
                  <VpTreeselect
                    class="vp-mt-16"
                    :disabled="!applyPrintBadgeCustomFields || !$v.printBadgeMetadataTemp[key].userTypes.$each.$iter[signOutCurrentUserTypeIndex].$model.permitted"
                    :showPlaceholderIcon="true"
                    width="416"
                    label="Custom field (optional)"
                    :showOptionsBorder="true"
                    valueFormat="object"
                    v-model="
                      $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                        signOutUserTypeIndex
                      ].printBadgeCustomFields.$model
                    "
                    :options="signOutCustomFieldsOption(signOutCurrentUserTypeIndex)"
                    :optionsKey="signOutOptionsKey"
                    @deselect="signOutDeselectHandler($event, signOutCurrentUserTypeIndex)"
                    :isMultiple="true"
                    :disableBranchNodes="true"
                  />
                  <svg
                    v-show="!applyPrintBadgeCustomFields"
                    class="lock-icon"
                    :class="{'lock-icon-with-value': $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                      signOutCurrentUserTypeIndex
                      ].printBadgeCustomFields.$model && $v.printBadgeMetadataTemp[key].userTypes.$each.$iter[
                      signOutCurrentUserTypeIndex
                      ].printBadgeCustomFields.$model.length}"
                    width="12"
                    height="16"
                    v-b-tooltip
                    id="sign-out-lock-icon"
                    viewBox="0 0 17 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.2691 7.29675V5.68077C14.2363 4.16287 13.614 2.71827 12.5357 1.65644C11.4574 0.594606 10.0087 0 8.5 0C6.99132 0 5.54264 0.594606 4.46431 1.65644C3.38597 2.71827 2.76374 4.16287 2.73092 5.68077V7.29675C2.00664 7.29675 1.31202 7.5863 0.799869 8.1017C0.287721 8.6171 0 9.31614 0 10.045V19.2517C0 19.9806 0.287721 20.6796 0.799869 21.195C1.31202 21.7104 2.00664 22 2.73092 22H14.2691C14.9934 22 15.688 21.7104 16.2001 21.195C16.7123 20.6796 17 19.9806 17 19.2517V10.045C17 9.31614 16.7123 8.6171 16.2001 8.1017C15.688 7.5863 14.9934 7.29675 14.2691 7.29675ZM9.591 16.1929C9.591 16.4845 9.47591 16.7641 9.27106 16.9702C9.0662 17.1764 8.78835 17.2922 8.49863 17.2922C8.20892 17.2922 7.93107 17.1764 7.72621 16.9702C7.52135 16.7641 7.40626 16.4845 7.40626 16.1929V13.1011C7.40626 12.8095 7.52135 12.5299 7.72621 12.3238C7.93107 12.1176 8.20892 12.0018 8.49863 12.0018C8.78835 12.0018 9.0662 12.1176 9.27106 12.3238C9.47591 12.5299 9.591 12.8095 9.591 13.1011V16.1929ZM12.0843 7.29675H4.91566V5.68077C4.94143 4.74134 5.33037 3.8491 5.99975 3.1938C6.66914 2.53851 7.56615 2.17187 8.5 2.17187C9.43385 2.17187 10.3309 2.53851 11.0002 3.1938C11.6696 3.8491 12.0586 4.74134 12.0843 5.68077V7.29675Z"
                      fill="#103F5E"
                    />
                  </svg>
                  <b-tooltip
                  id="lock-icon-tooltip"
                  target="sign-out-lock-icon"
                  triggers="click blur"
                  placement="topright"
                  >
                    <ul style="margin-bottom: 0px">
                      <li
                        class="feature-availability"
                        style="margin-bottom: 8px; text-align: start"
                      >
                        {{ $t("customFields.form.lockedFeature") }}
                      </li>

                      <li class="feature-upgrade" style="text-align: start">
                        {{ $t("customFields.form.lockedFeatureInfo") }}
                        <span
                          class="mail"
                          style="
                            color: #2680eb;
                            font-weight: 700;
                            text-decoration: underline;
                          "
                          >cs@lamasatech.com.</span
                        >
                      </li>
                    </ul>
                  </b-tooltip>
            
                  <template v-if="applyPrintBadgeCustomFields">
                    <p class="maximum-custom-field-note">
                      <template v-if="!$v.printBadgeMetadataTemp[key].userTypes.$each.$iter[signOutCurrentUserTypeIndex].$model.permitted">
                          <b>Note:</b> You cannot access the custom fields because you do not have permission to access this user type.
                      </template>
                      <template v-else>
                          <b>Note:</b> A maximum of 4 custom fields can be printed.
                      </template>
                    </p>
                  </template>
                  </div>
                </ul>
              <hr class="vp-mt-32 vp-mb-32" />
              </template>
            <!-- </template> -->
          </div>
        </div>
        <hr
          v-if="
            index < applyOutputSettings.length - 1 &&
            !displayCustomFields(output)
          "
        />
      </div>
      <!-- end:: print bade -->

      <!-- start:: save data -->
      <div v-if="output.name === 'save_data'">
        <div class="subheader-container header-title">
          <h5 class="vp-mb-24 fw-700">{{ $t('journeyBuilder.saveData') }}</h5>

          <div
            v-for="(setting, indx) in output.chlidren"
            :key="indx"
            class="setting-container"
          >
            <span>{{ setting.label }}</span>
            <b-form-checkbox
              class="switch-gray custom-switch-input"
              switch
              size="lg"
              v-model="
                $v.applyOutputSettings.$each.$iter[index].chlidren
                  .save_scan_image.value.$model
              "
            ></b-form-checkbox>
          </div>
          <hr v-if="index < applyOutputSettings.length - 1" />
        </div>
      </div>
      <!-- end:: save data -->

      <!-- start:: door relay -->
      <div v-if="output.name === 'door_relay'">
        <div class="subheader-container header-title">
          <h5 class="vp-mb-24 fw-700">{{ $t('journeyBuilder.flow.doorRelay') }}</h5>
          <div class="checkbox-container">
            <b-form-checkbox
              @change="onLoginModeChange(output, 'checkIn')"
              v-model="$v.applyOutputSettings.$each.$iter[index].checkIn.$model"
              >{{ $t("common.checkIn") }}</b-form-checkbox
            >
            <b-form-checkbox
              @change="onLoginModeChange(output, 'signIn')"
              v-model="$v.applyOutputSettings.$each.$iter[index].signIn.$model"
              >{{ $t("common.signIn") }}</b-form-checkbox
            >
            <b-form-checkbox
              @change="onLoginModeChange(output, 'signOut')"
              v-model="$v.applyOutputSettings.$each.$iter[index].signOut.$model"
              >{{ $t('common.signOut') }}</b-form-checkbox
            >
          </div>
        </div>
        <hr v-if="index < applyOutputSettings.length - 1" />
      </div>
      <!-- start:: end relay -->

      <!-- start:: Weigand -->
      <div v-if="output.name === 'enable_weigand_output'">
        <div class="subheader-container header-title">
          <h5 class="vp-mb-24 fw-700">{{ $t('journeyBuilder.flow.weigandOutput') }}</h5>
          <h5 class="vp-mb-24" style="color: #787878 !important;">{{ $t('journeyBuilder.sendRFID')}}</h5>

          <div
            v-for="(setting, indx) in output.chlidren.weigand_output_settings
              .value"
            class="setting-container"
            :key="indx"
          >
            <span>{{ setting.name }}</span>
            <b-form-checkbox
              class="switch-gray custom-switch-input"
              switch
              size="lg"
              v-model="
                $v.applyOutputSettings.$each.$iter[index].chlidren
                  .weigand_output_settings.value.$each.$iter[indx].value.$model
              "
            ></b-form-checkbox>
          </div>
        </div>
        <hr v-if="index < applyOutputSettings.length - 1" />
      </div>
      <!-- end:: Weigand -->
    </div>

      <hr class="vertical-line" v-if="!onlyPrintBadgeSelected" />
      <div class="modal-actions-btns">
        <VpButton :text="$t('common.save')" :disabled="!$v.$anyDirty" @click="submit" />
        <VpButton
          text="Cancel"
          :disabled="false"
          :isDanger="true"
          @click="onHideModal"
        />
      </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";
import { journeyBuilderSettingsIDS } from "@/utils/Constants.js";
export default {
  props: {
    output: {
      default: () => [],
      type: Array,
    },
    isAttendanceModeSelected: {
      type: Boolean,
      default: false,
    },
    isTemerpatureCheckSelected: {
      type: Boolean,
      default: false,
    },
    isHostSelected: {
      type: Boolean,
      default: false,
    },
    printBadgeCustomFields: {
      type: Object,
      default: () => {},
    },
    // printBadgeMetadata: {
    //   type: [Object, Array],
    //   default: () => [],
    // },
  },
  computed: {
    ...mapGetters("authfack", ["getCurrentPlan"]),
    applyPrintBadgeCustomFields() {
      return this.getCurrentPlan == 2 || this.getCurrentPlan == 3;
    },
    checkInUserTypeIndex() {
      return this.printBadgeMetadataTemp.checkInCustomFileds.userTypes.findIndex(
        userType => userType.id == this.checkInSelectedUserType
      );
    },
    signInUserTypeIndex() {
      return this.printBadgeMetadataTemp.signInCustomFileds.userTypes.findIndex(
        userType => userType.id == this.signInSelectedUserType
      );
    },
    signOutUserTypeIndex() {
      return this.printBadgeMetadataTemp.signOutCustomFileds.userTypes.findIndex(
        userType => userType.id == this.signOutSelectedUserType
      );
    }
  },
  validations: {
    printBadgeMetadataTemp: {
      signInCustomFileds: {
        userTypes: {
          $each: {
            printBadgeCustomFields: {},
          },
        },
      },
      signOutCustomFileds: {
        userTypes: {
          $each: {
            printBadgeCustomFields: {},
          },
        },
      },
      checkInCustomFileds: {
        userTypes: {
          $each: {
            printBadgeCustomFields: {},
          },
        },
      },
    },
    applyOutputSettings: {
      $each: {
        signIn: {},
        signOut: {},
        checkIn: {},
        chlidren: {
          print_badge_early_sign_out_reason: {
            value: {},
          },
          print_badge_host: {
            value: {},
          },
          print_badge_journey_company_logo: {
            value: {},
          },
          print_badge_late_sign_in_reason: {
            value: {},
          },
          show_company_name: {
            value: {},
          },
          show_date_time: {
            value: {},
          },
          show_name: {
            value: {},
          },
          show_photo: {
            value: {},
          },
          show_temperature: {
            value: {},
          },
          show_user_type: {
            value: {},
          },
          save_scan_image: {
            value: {},
          },
          weigand_output_settings: {
            value: {
              $each: {
                value: {},
              },
            },
          },
        },
      },
    },
  },

  data() {
    return {
      signInOptionsKey: 0,
      signOutOptionsKey: 0,
      checkInOptionsKey: 0,
      onlyPrintBadgeSelected:false,
      signInCurrentUserTypeIndex: 0,
      checkInCurrentUserTypeIndex: 0,
      signOutCurrentUserTypeIndex: 0,
      checkInSelectedUserType: 0,
      signInSelectedUserType: 0,
      signOutSelectedUserType: 0,

      printBadgeMetadataTemp: {},
      applyOutputSettings: [],
      tempOutputSettings: [],
      optionsWeigand: [
        {
          id: "rfid",
          name: this.$t("journeyBuilder.flow.outputSettingsRFID"),
          value: false,
        },
        {
          id: "face_recognition",
          name: this.$t("jouneyBuilder.flow.outputSettingsFacialRecognition"),
          value: false,
        },
      ],
      deselectOutput: "",
      latestLoginMode: "",
      printBadgeDisplayableSettingsIDS: [
        journeyBuilderSettingsIDS.show_temperature,
        journeyBuilderSettingsIDS.print_badge_host,
        journeyBuilderSettingsIDS.print_badge_late_sign_in_reason,
        journeyBuilderSettingsIDS.print_badge_early_sign_out_reason,
      ],
    };
  },
  methods: {
    

    checkInCustomFieldsOptions(userTypeIndex){
      const clonePrintBadgeSection = cloneDeep(this.printBadgeMetadataTemp.checkInCustomFileds.sections)
      let applicableUserProfileSections = []
      const userTypesWithSections = cloneDeep(this.printBadgeMetadataTemp.checkInCustomFileds).sections?.length
                        ? cloneDeep(this.printBadgeMetadataTemp.checkInCustomFileds).userTypes : cloneDeep(this.printBadgeMetadataTemp.checkInCustomFileds).userTypes.filter(userType =>
                            userType.sections?.some(section => !!section.children?.length)
                          );
      applicableUserProfileSections  = userTypesWithSections[userTypeIndex].sections.filter(section=>!!section.children.length)

      const selectedFields = cloneDeep(this.printBadgeMetadataTemp.checkInCustomFileds).userTypes[userTypeIndex].printBadgeCustomFields.map(field=>field.id)
     
      const options = [...applicableUserProfileSections,...clonePrintBadgeSection]

      if(this.printBadgeMetadataTemp.checkInCustomFileds.userTypes[userTypeIndex].printBadgeCustomFields.length > 3){  
        options.forEach(section=>{
            section.children.forEach(field=>{
              if(!selectedFields.some(id=> id == field.id))
                field.isDisabled = true
              else
                field.isDisabled = false
          })
        })
      }
      else{
        options.forEach(section=>{
            section.children.forEach(field=>{
              Object.assign(field,{isDisabled:false})
          })
        })
      }

      return options
    },
    checkInDeselectHandler(deselectOutput, userTypeIndex) {
      setTimeout(() => {
        if (this.printBadgeMetadataTemp.checkInCustomFileds.userTypes[userTypeIndex].printBadgeCustomFields.filter(field=>field.id != deselectOutput.id).length < 4){  
        this.checkInOptionsKey++;
      }
      }, 50);
    },

    signInCustomFieldsOption(userTypeIndex){
      const clonePrintBadgeSection = cloneDeep(this.printBadgeMetadataTemp.signInCustomFileds.sections)

      let applicableUserProfileSections = []
      const userTypesWithSections = cloneDeep(this.printBadgeMetadataTemp.signInCustomFileds).sections?.length
                        ? cloneDeep(this.printBadgeMetadataTemp.signInCustomFileds).userTypes : cloneDeep(this.printBadgeMetadataTemp.signInCustomFileds).userTypes.filter(userType =>
                            userType.sections?.some(section => !!section.children?.length)
                          );
      applicableUserProfileSections  = userTypesWithSections[userTypeIndex].sections.filter(section=>!!section.children.length)

      const selectedFields = cloneDeep(this.printBadgeMetadataTemp.signInCustomFileds).userTypes[userTypeIndex].printBadgeCustomFields.map(field=>field.id)
      const options = [...applicableUserProfileSections,...clonePrintBadgeSection]

      if(this.printBadgeMetadataTemp.signInCustomFileds.userTypes[userTypeIndex].printBadgeCustomFields.length > 3){  
        options.forEach(section=>{
            section.children.forEach(field=>{
              if(!selectedFields.some(id=> id == field.id))
                field.isDisabled = true
              else
                field.isDisabled = false
          })
        })
      }
      else{
       options.forEach(section=>{
            section.children.forEach(field=>{
              Object.assign(field,{isDisabled:false})
          })
        })
      }

      return options
    },
    signInDeselectHandler(deselectOutput, userTypeIndex) {
      setTimeout(() => {
        if (this.printBadgeMetadataTemp.signInCustomFileds.userTypes[userTypeIndex].printBadgeCustomFields.filter(field=>field.id != deselectOutput.id).length < 4){  
        this.signInOptionsKey++;
      }
      }, 50);
    },
    signOutCustomFieldsOption(userTypeIndex){
      const clonePrintBadgeSection = cloneDeep(this.printBadgeMetadataTemp.signOutCustomFileds.sections)
      let applicableUserProfileSections = []
      const userTypesWithSections = cloneDeep(this.printBadgeMetadataTemp.signOutCustomFileds).sections?.length
                        ? cloneDeep(this.printBadgeMetadataTemp.signOutCustomFileds).userTypes : cloneDeep(this.printBadgeMetadataTemp.signOutCustomFileds).userTypes.filter(userType =>
                            userType.sections?.some(section => !!section.children?.length)
                          );
      applicableUserProfileSections  = userTypesWithSections[userTypeIndex].sections.filter(section=>!!section.children.length)

     const selectedFields = cloneDeep(this.printBadgeMetadataTemp.signOutCustomFileds).userTypes[userTypeIndex].printBadgeCustomFields.map(field=>field.id)
      const options = [...applicableUserProfileSections,...clonePrintBadgeSection]

      if(this.printBadgeMetadataTemp.signOutCustomFileds.userTypes[userTypeIndex].printBadgeCustomFields.length > 3){  
        options.forEach(section=>{
            section.children.forEach(field=>{
              if(!selectedFields.some(id=> id == field.id))
                field.isDisabled = true
              else
                field.isDisabled = false
          })
        })
      }
      else{
        applicableUserProfileSections.forEach(section=>{
            section.children.forEach(field=>{
              Object.assign(field,{isDisabled:false})
          })
        })
      }
      return options

    },
    signOutDeselectHandler(deselectOutput, userTypeIndex) {
      setTimeout(() => {
        if (this.printBadgeMetadataTemp.signOutCustomFileds.userTypes[userTypeIndex].printBadgeCustomFields.filter(field=>field.id != deselectOutput.id).length < 4){  
        this.signOutOptionsKey++;
      }
      }, 50);
    },
    displayCustomFieldSection(key){
      if(key == 'checkInCustomFileds'){
        return this.printBadgeCustomFields[key].userTypes.some(userType=> !!userType.sections.some(section => !!section.checkInCustomFields.length))
      }else if(key == 'signInCustomFileds'){
        return this.printBadgeCustomFields[key].userTypes.some(userType=> !!userType.sections.some(section => !!section.signInCustomFields.length))
      }else if(key == 'signOutCustomFileds'){
        return this.printBadgeCustomFields[key].userTypes.some(userType=> !!userType.sections.some(section => !!section.signOutCustomFields.length))
      }
    },
    onUserTypeSelect(userTypeIndex, key, id) {
      if (key == "signInCustomFileds") {
        this.signInCurrentUserTypeIndex = userTypeIndex;
        this.signInSelectedUserType = id;
      }
      else if (key == "checkInCustomFileds") {
        this.checkInCurrentUserTypeIndex = userTypeIndex;
        this.checkInSelectedUserType = id;
      }
      else if (key == "signOutCustomFileds") {
        this.signOutCurrentUserTypeIndex = userTypeIndex;
        this.signOutSelectedUserType = id;
      }
    },
    displayCustomFields(printBadgeOutput) {
      let displayPrintBadgeCustomFields = false;
      displayPrintBadgeCustomFields =
        (printBadgeOutput.signIn &&
          this.printBadgeCustomFields.signInCustomFileds.userTypes &&
          (this.printBadgeCustomFields.signInCustomFileds.userTypes.some(userType=> !!userType.sections.some(section => !!section.children.length))) 
          || !!this.printBadgeCustomFields.signInCustomFileds.sections?.length)||
        (printBadgeOutput.checkIn &&
          this.printBadgeCustomFields.checkInCustomFileds.userTypes &&
          (this.printBadgeCustomFields.checkInCustomFileds.userTypes.some(userType=> !!userType.sections.some(section => !!section.children.length))) 
          || !!this.printBadgeCustomFields.checkInCustomFileds.sections?.length) ||
        (printBadgeOutput.signOut &&
          this.printBadgeCustomFields.signOutCustomFileds.userTypes &&
          (this.printBadgeCustomFields.signOutCustomFileds.userTypes.some(userType=> !!userType.sections.some(section => !!section.children.length))) 
          || !!this.printBadgeCustomFields.signOutCustomFileds.sections?.length) ;
      return displayPrintBadgeCustomFields;
    },
    isDisplayed(outputSetting, output) {
      if (!this.printBadgeDisplayableSettingsIDS.includes(outputSetting.id))
        return true;

      let display = false;
      // Check if temperature should be displayed
      if (
        outputSetting.id == journeyBuilderSettingsIDS.show_temperature &&
        this.isTemerpatureCheckSelected &&
        (output.checkIn || output.signIn)
      ) {
        display = true;
      }

      // Check if host badge should be printed
      if (
        outputSetting.id == journeyBuilderSettingsIDS.print_badge_host &&
        this.isHostSelected &&
        (output.checkIn || output.signIn)
      ) {
        display = true;
      }

      // Check if late sign-in reason should be printed
      if (
        outputSetting.id ==
          journeyBuilderSettingsIDS.print_badge_late_sign_in_reason &&
        this.isAttendanceModeSelected &&
        output.signIn
      ) {
        display = true;
      }

      // Check if early sign-out reason should be printed
      if (
        outputSetting.id ==
          journeyBuilderSettingsIDS.print_badge_early_sign_out_reason &&
        this.isAttendanceModeSelected &&
        output.signOut
      ) {
        display = true;
      }

      //Reset setting value to default (false) if it was unchecked and checked again.
      // if (!display) outputSetting.value = false;

      return display;
    },
    onLoginModeChange(output, targetObjectKey) {
      //If all login modes are deselected ,display confirmation modal + save latest deselected option (to be used in case of canelling action)
      if (!output.signIn && !output.signOut && !output.checkIn) {
        this.deselectOutput = output;
        this.latestLoginMode = targetObjectKey;
        this.$bvModal.show("removeOutput_ConfirmModal");
      }
    },
    onConfirmationModalSubmit() {
      //Reset all selected customfields from user types
      Object.keys(this.printBadgeMetadataTemp).forEach(key=>{
        this.printBadgeMetadataTemp[key].userTypes.forEach(userType => {
            userType.printBadgeCustomFields = []
        })
      })

      //Remove output option from current applyOutputSettings object
      this.applyOutputSettings = this.applyOutputSettings.filter(
        (setting) => setting.name !== this.deselectOutput.name
      );

      //Remove output option from current output object on submit builder(parent) page
      this.$emit("removeOutput", this.deselectOutput);
      this.$bvModal.hide("removeOutput_ConfirmModal");

      //Hide output modal if all "outputs" are deselected
      if (!this.applyOutputSettings?.length) this.$bvModal.hide("output-modal");
    },
    onHideModal() {
      this.$emit("undoOutputChanges", this.tempOutputSettings);
      this.$bvModal.hide("output-modal");
    },
    onCancel() {
      //Set value of latest unselected option to true
      this.deselectOutput[this.latestLoginMode] = true;
      this.$bvModal.hide("removeOutput_ConfirmModal");
    },
    submit() {
      this.$emit("updateOutput", this.applyOutputSettings);
       const printBadgeOption = this.applyOutputSettings.find(({ id }) => id == 7)

      if (printBadgeOption){
        const { signIn, signOut, checkIn } = printBadgeOption

        const fieldsMap = [
          { enabled: checkIn, key: 'checkInCustomFileds' },
          { enabled: signIn, key: 'signInCustomFileds' },
          { enabled: signOut, key: 'signOutCustomFileds' }
        ]

        fieldsMap.forEach(({ enabled, key }) => {
          if (!enabled && this.printBadgeMetadataTemp[key]) {
            this.printBadgeMetadataTemp[key].userTypes.forEach(userType => {
              userType.printBadgeCustomFields = []
            })
          }
        })
      }
      this.$emit("updatePrintBadgeCustomFields", this.printBadgeMetadataTemp);
      this.$bvModal.hide("output-modal");
    },
  },
  mounted() {
    this.applyOutputSettings = cloneDeep(this.output);
    this.tempOutputSettings = cloneDeep(this.output);
    this.onlyPrintBadgeSelected = this.applyOutputSettings.some(output=> output.name == "print_badge") && this.applyOutputSettings.length == 1
    // Object.keys(this.printBadgeCustomFields).forEach(key=>{
    //   //check for visit section and filter usertypes that have no user profile custom fields
    //   if(key == 'checkInCustomFileds'){
    //   this.printBadgeCustomFields[key].userTypes = this.printBadgeCustomFields[key].sections.some(section => !!section.checkInCustomFields.length)
    //    ? this.printBadgeCustomFields[key].userTypes : this.printBadgeCustomFields[key].userTypes.filter( userType => userType.sections.some(section=> !!section.children?.length)) 
    //   }else if(key == 'signInCustomFileds'){
    //   this.printBadgeCustomFields[key].userTypes = this.printBadgeCustomFields[key].sections.some(section => !!section.signInCustomFields.length)
    //    ? this.printBadgeCustomFields[key].userTypes : this.printBadgeCustomFields[key].userTypes.filter( userType => userType.sections.some(section=> !!section.children?.length)) 
    //   }else if(key== 'signOutCustomFileds'){
    //   this.printBadgeCustomFields[key].userTypes = this.printBadgeCustomFields[key].sections.some(section => !!section.signOutCustomFields.length)
    //    ? this.printBadgeCustomFields[key].userTypes : this.printBadgeCustomFields[key].userTypes.filter( userType => userType.sections.some(section=> !!section.children?.length)) 
    //   }
    // })
    this.printBadgeMetadataTemp = cloneDeep(this.printBadgeCustomFields);
    const visibleCheckInUserTypes = this.printBadgeCustomFields.checkInCustomFileds?.sections?.length
                        ? this.printBadgeCustomFields.checkInCustomFileds?.userTypes
                        : this.printBadgeCustomFields.checkInCustomFileds?.userTypes.filter(userType =>
                            userType.sections?.some(section => !!section.children?.length)
                          )

    this.checkInSelectedUserType = visibleCheckInUserTypes ? visibleCheckInUserTypes[0]?.id : 0;
    const visibleSignInUserTypes = this.printBadgeCustomFields.signInCustomFileds?.sections?.length
                        ? this.printBadgeCustomFields.signInCustomFileds?.userTypes
                        : this.printBadgeCustomFields.signInCustomFileds?.userTypes.filter(userType =>
                            userType.sections?.some(section => !!section.children?.length)
                          )
    this.signInSelectedUserType = visibleSignInUserTypes ? visibleSignInUserTypes[0]?.id : 0;

    const visibleSignOutUserTypes = this.printBadgeCustomFields.signOutCustomFileds?.sections?.length
                        ? this.printBadgeCustomFields.signOutCustomFileds?.userTypes
                        : this.printBadgeCustomFields.signOutCustomFileds?.userTypes.filter(userType =>
                            userType.sections?.some(section => !!section.children?.length)
                          )
    this.signOutSelectedUserType = visibleSignOutUserTypes ? visibleSignOutUserTypes[0]?.id : 0;
                          
    this.printBadgeMetadataTemp.signInCustomFileds?.userTypes?.forEach(userType => {
      if (Array.isArray(userType.printBadgeCustomFields)) {
        userType.printBadgeCustomFields = userType.printBadgeCustomFields.filter(field => field !== null);
      }
    });
    this.printBadgeMetadataTemp.checkInCustomFileds?.userTypes?.forEach(userType => {
      if (Array.isArray(userType.printBadgeCustomFields)) {
        userType.printBadgeCustomFields = userType.printBadgeCustomFields.filter(field => field !== null);
      }
    });
    this.printBadgeMetadataTemp.signOutCustomFileds?.userTypes?.forEach(userType => {
      if (Array.isArray(userType.printBadgeCustomFields)) {
        userType.printBadgeCustomFields = userType.printBadgeCustomFields.filter(field => field !== null);
      }
    });
    console.log(this.printBadgeMetadataTemp)

    const correctOrder = [
      "print_badge_journey_company_logo",
      "show_name",
      "show_user_type",
      "show_photo",
      "show_temperature",
      "print_badge_host",
      "print_badge_late_sign_in_reason",
      "print_badge_early_sign_out_reason"
    ];
    // Loop through the array and assign visibleIndex to each child
    this.applyOutputSettings.forEach((setting) => {
      if (setting.id == 7) { // print badge
        const children = setting.chlidren;
        for (const key in children) {
          if (correctOrder.includes(key)) {
            children[key].visibleIndex = correctOrder.indexOf(key);
          }
        }

        // Sort and replace children object
        const sortedChildren = Object.entries(children)
          .sort(([, a], [, b]) => a.visibleIndex - b.visibleIndex)
          .reduce((acc, [key, val]) => {
            acc[key] = val;
            return acc;
          }, {});

        setting.chlidren = sortedChildren;
      }
    });
  },
};
</script>

<style lang="scss">
div#output-modal___BV_modal_content_{
  overflow: visible !important;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.25s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.display-setting {
  transition: all 0.25s ease-in-out;
  opacity: 1;
  scale: 1;
}
.display-none-animated {
  opacity: 0 !important;
  scale: 0 !important;
  height: 0 !important;
  margin: unset !important;
  padding: unset !important;
  transition: all 0.25s ease-in-out;
}

#journey-logo-tooltip {
  width: 137px;
  height: 126px;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  .tooltip-inner {
    box-shadow: unset;
  }
}
div#output-modal___BV_modal_body_ {
  padding: 40px 0 23px 0;
  overflow-x: hidden;
}
a.mailto {
    text-decoration: underline !important;
    font-weight: 700;
}
.output-setting {
  width: 416px;
  margin: auto;
  hr {
    margin-top: 32px;
  }
  .fw-700 {
    font-weight: 700 !important;
  }
  .header h5 {
    font-size: 17px;
    font-weight: 700;
    line-height: 20.4px;
    color: #000000;
    text-align: center;
  }
  .subheader-container {
    margin: 32px 0;
  }
  .header-title h5 {
    color: #4A4A4A !important;
  }
  .checkbox-container {
    width: 310px;
    display: flex;
    // justify-content: space-between;
    gap: 34px;
    .custom-control-label {
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      letter-spacing: 0.25px;
      color: #787878;
      white-space: nowrap;
    }
    .custom-control-input:checked ~ .custom-control-label {
      color: #103f5e;
      font-size: 16px;
      font-weight: 700;
      line-height: 19.2px;
      letter-spacing: 0.25px;
    }
  }
  h5 {
    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
  }
  .save-btn {
    background: #103f5e;
    width: 416px;
    height: 44px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    letter-spacing: 0.25px;
    color: #ffffff;
    margin: 8px auto 17px;
  }
  .save-btn:disabled {
    background: #9fb2bf;
  }
  .multiselect__content-wrapper {
    position: relative !important;
  }
  .setting-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 416px;
    height: 55px;
    padding: 22px 20px 21px;
    background-color: #f2f2f2;
    margin-bottom: 16px;

    span {
      font-size: 16px;
      font-weight: 700;
      line-height: 19.2px;
      color: #787878;
    }
  }
  .switch-gray {
    .custom-control-input:checked ~ .custom-control-label::before {
      position: absolute;
      top: unset !important;
      width: 43px;
      height: 21px;
      background: #d1d1d1;
      border: 1.5px solid #d1d1d1 !important;
      border-radius: 13.5px;
    }

    .custom-control-input:checked ~ .custom-control-label::after {
      width: 21px !important;
      height: 21px !important;
      top: unset !important;
      background-color: #34c38f;
    }

    .custom-control-label::before {
      top: unset !important;
      width: 43px !important;
      height: 21px !important;
      background: #d1d1d1;
      border: 1.5px solid #d1d1d1 !important;
      border-radius: 13.5px;
    }
    .custom-control-label::after {
      width: 21px !important;
      height: 21px !important;
      top: unset !important;
      background: #939393;
      box-shadow: -1px 0px 3px rgba(0, 0, 0, 0.18) !important;
    }
  }
  .background-blue {
    background-color: #103f5e !important;
  }
  .inactive-tag {
    background-color: #c7c7c7;
    border-radius: 13.5px;
  }

  .user-type-tag {
    padding: 8px 16px;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    color: #ffffff;
  }

  .print-badge-user-types-container {
    display: flex;
    flex-wrap: wrap;
  }

  .print-badge-user-types-container li:not(:last-child) {
    display: flex;
    margin: 16px 16px 16px 0;
    cursor: pointer;
  }

  .print-badge-user-types-container li:last-child {
    width: 100%;
    display: block;
    margin-top: 1rem;
  }
  .maximum-custom-field-note {
    margin: 8px 0 0 20px;
    color: #787878;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    b {
      font-weight: 700;
    }
  }

  .print-badge-custom-field-header {
    color: #787878;
    font-family: Lato;
    font-weight: 600;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
  }

  .print-badge-user-types-container {
  position: relative;
  // display: inline-block;
}

.lock-icon {
  position: absolute;
  right: 12px;
  top: 58%;
  transform: translateY(-50%);
  // cursor: pointer;
  color: #103F5E;
  font-size: 16px;
  pointer-events: auto;
}
.lock-icon-with-value {
  top: 31% !important;
}

.vue-treeselect--disabled.vue-treeselect--has-value .lock-icon {
  top: 16px;
  transform: none;
}

.lock-tooltip {
  font-size: 14px;
  line-height: 1.4;
}
.lock-tooltip a {
  color: #103F5E;
  text-decoration: underline;
}

.vue-treeselect--disabled .vue-treeselect__control {
  position: relative;
}

.vue-treeselect--disabled.vue-treeselect--has-value
  .vue-treeselect__control::after {
  top: 47%;
  transform: none;
}
// .vue-treeselect--disabled .vue-treeselect__control-arrow {
//   display: none !important;
// }

.vue-treeselect * {
  transition: none !important;
  animation: none !important;
}
}
.lock-tooltip p {
  text-align: left !important;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  width: 192px !important;
}

div#lock-icon-tooltip .tooltip-inner{
  width: 224px !important;
  max-width: 224px !important;
  padding: 16px !important;
}

svg:focus {
  outline: none !important;
}
</style>